import React from "react";
import {Typography, Divider} from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

import NavigationButton from "../NavigationButton";

const styles = {
    sectionHeader: {
        fontSize: '0.7rem'
    },
    divider: {
        my: '0.2rem'
    }
};

export default function QAMenuSnippet({permissions}) {
    if (!permissions.canQA) {
        return null;
    }

    return (
        <>
            <Typography variant="overline" sx={styles.sectionHeader}>QA</Typography>

            <NavigationButton displayName="QA Schedule" toLink="/qa-schedule">
                <ThumbUpIcon/>
            </NavigationButton>
            <Divider sx={styles.divider}/>
        </>
    );
}